import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const contentService = {
    // Get content for a specific page (e.g., 'home', 'about')
    async getPageContent(pageId) {
        try {
            const docRef = doc(db, 'site_content', pageId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                return docSnap.data();
            }
            return null;
        } catch (error) {
            console.error(`Error getting content for ${pageId}:`, error);
            throw error;
        }
    },

    // Update content
    async updatePageContent(pageId, contentData) {
        try {
            const docRef = doc(db, 'site_content', pageId);
            // setDoc with merge: true handles both creation and update
            await setDoc(docRef, {
                ...contentData,
                updatedAt: new Date()
            }, { merge: true });
            return true;
        } catch (error) {
            console.error(`Error updating content for ${pageId}:`, error);
            throw error;
        }
    }
};